export const normalizeFetchDisciplinesResponse = (response) => {
    return response.map(discipline => ({
        id: discipline.id,
        visualId: discipline.visual_id,
        name: discipline.name,
        description: discipline.description,
        isActive: discipline.is_active,
        conceptualLabels: discipline.conceptual_labels
    })).sort((a, b) => a.visualId - b.visualId)
}